import {
  DateTimeField,
  WhatsAppPhoneField,
} from "common/Components/TableFields/TableFields";
import constants from "constants/constants";
import {
  DATE_WITH_FULL_MONTH_FORMAT,
  DEFAULT_YEAR_MONTH_DATE_FORMAT,
} from "constants/date-fns/dateTime.constant";
import { addDays, format, isSameDay, parse } from "date-fns";
import React from "react";
import MoneyField from "ui/modules/MoneyField";
import { is_empty } from "features/Common/utils/common.utils";
import { listingTypeOptions } from "../../AllTransaction/AllTransactionTableConfig";
import { StatusField, TooltipHeaderField } from "../TableFields/TableFields";
import {
  FIELD_DATA,
  FORM_DATA,
  HEADER_NOTE,
  DISPUTE_STATUS_FILTER_OPTIONS,
  DAY_OFFSETS,
} from "./disputes.constant";
import { DisputeDocumentLinks } from "../DisputeDocumentLinks/DisputeDocumentLinks";
import {
  getDisputeDueDateOptions,
  getDisputeDueDateSetFilterTag,
} from "../utils/DistoryHistory.utils";

export const getTableConfig = [
  {
    field: FIELD_DATA.customer_name,
    headerName: FORM_DATA.customer_name,
    avatar: true,
    isPrimary: true,
    isDrawerTitle: true,
    emptyField: "N/A",
    sortable: false,
    fixed: "left",
    width: "200px",
  },
  {
    field: FIELD_DATA.dispute_due_date,
    headerName: FORM_DATA.dispute_due_date,
    renderHeader: () => (
      <TooltipHeaderField
        label={FORM_DATA.dispute_due_date}
        note={HEADER_NOTE.dispute_due_date}
      />
    ),
    valueFormatter: (record) => (
      <DateTimeField record={record} source={FIELD_DATA.dispute_due_date} />
    ),
    emptyField: "N/A",
    sortable: false,
    noWrap: true,
    width: "215px",
  },
  {
    field: FIELD_DATA.customer_phone,
    headerName: FORM_DATA.customer_phone,
    valueFormatter: (record) => (
      <WhatsAppPhoneField record={record} source={FIELD_DATA.customer_phone} />
    ),
    sortable: false,
    isCollapsed: true,
    width: "140px",
  },
  {
    field: FIELD_DATA.customer_email,
    headerName: FORM_DATA.customer_email,
    emptyField: "N/A",
    sortable: false,
    width: "160px",
    columnClassName: "word_break",
    isCollapsed: true,
  },
  {
    field: FIELD_DATA.listing_title,
    headerName: FORM_DATA.listing_title,
    sortable: false,
    isCollapsed: true,
    width: "120px",
  },
  {
    field: FIELD_DATA.listing_type,
    headerName: FORM_DATA.listing_type,
    valueFormatter: (record) =>
      constants.schedule_type[record.listing_type].name ?? "N/A",
    sortable: false,
    isCollapsed: true,
    width: "150px",
  },
  {
    field: FIELD_DATA.transaction_amount,
    headerName: FORM_DATA.transaction_amount,
    valueFormatter: (record) => (
      <MoneyField
        record={record}
        source={FIELD_DATA.transaction_amount}
        creator_sales={false}
      />
    ),
    sortable: false,
    width: "120px",
  },
  {
    field: FIELD_DATA.transaction_id,
    headerName: FORM_DATA.transaction_id,
    emptyField: "N/A",
    sortable: false,
    isCollapsed: true,
    width: "120px",
  },
  {
    field: FIELD_DATA.transaction_date,
    headerName: FORM_DATA.transaction_date,
    valueFormatter: (record) => (
      <DateTimeField record={record} source={FIELD_DATA.transaction_date} />
    ),
    sortable: false,
    noWrap: true,
  },
  {
    field: FIELD_DATA.dispute_reason,
    headerName: FORM_DATA.dispute_reason,
    emptyField: "N/A",
    sortable: false,
    width: "200px",
    columnClassName: "word_break",
  },
  {
    field: FIELD_DATA.raised_date,
    headerName: FORM_DATA.dispute_raised_date,
    valueFormatter: (record) => (
      <DateTimeField record={record} source={FIELD_DATA.raised_date} />
    ),
    emptyField: "N/A",
    sortable: false,
    noWrap: true,
  },
  {
    field: FIELD_DATA.resolved_date,
    headerName: FORM_DATA.dispute_resolved_date,
    valueFormatter: (record) => (
      <DateTimeField record={record} source={FIELD_DATA.resolved_date} />
    ),
    emptyField: "N/A",
    sortable: false,
    noWrap: true,
  },
  {
    field: FIELD_DATA.documents,
    headerName: FORM_DATA.dispute_documents,
    renderHeader: () => (
      <TooltipHeaderField
        label={FORM_DATA.dispute_documents}
        note={HEADER_NOTE.dispute_documents_links}
      />
    ),
    valueFormatter: (record) =>
      is_empty(record[FIELD_DATA.documents]) ? (
        <span>N/A</span>
      ) : (
        <DisputeDocumentLinks record={record} />
      ),
    noWrap: true,
    sortable: false,
    width: "200px",
  },
  {
    field: FIELD_DATA.status,
    headerName: FORM_DATA.dispute_status,
    valueFormatter: (record) => (
      <StatusField record={record} source={FIELD_DATA.status} />
    ),
    sortable: false,
    isCollapsed: true,
    width: "170px",
  },
];

export const filterConfig = () => [
  {
    source: FIELD_DATA.customer_name,
    placeholder: FORM_DATA.customer_name,
    type: "input",
    disableContains: true,
  },
  {
    source: FIELD_DATA.customer_email,
    placeholder: FORM_DATA.customer_email,
    type: "input",
    disableContains: true,
  },
  {
    source: FIELD_DATA.customer_phone_number,
    placeholder: FORM_DATA.customer_phone,
    type: "input",
    disableContains: true,
  },
  {
    source: FIELD_DATA.listing_title,
    placeholder: FORM_DATA.listing_title,
    type: "input",
    disableContains: true,
  },
  {
    source: FIELD_DATA.listing_type,
    placeholder: FORM_DATA.listing_type,
    options: listingTypeOptions,
    type: "dropdown",
  },
  {
    source: FIELD_DATA.status,
    placeholder: FORM_DATA.dispute_status,
    options: DISPUTE_STATUS_FILTER_OPTIONS,
    type: "dropdown",
  },
  {
    source: FIELD_DATA.dispute_due_date,
    placeholder: FORM_DATA.dispute_due_date,
    options: getDisputeDueDateOptions(),
    type: "dropdown",
  },
  {
    source: `${FIELD_DATA.raised_date_filter}__start_range`,
    placeholder: `${FORM_DATA.dispute_raised_date}(From)`,
    type: "date",
  },
  {
    source: `${FIELD_DATA.raised_date_filter}__end_range`,
    placeholder: `${FORM_DATA.dispute_raised_date}(To)`,
    type: "date",
  },
  {
    source: `${FIELD_DATA.resolved_date_filter}__start_range`,
    placeholder: `${FORM_DATA.dispute_resolved_date}(From)`,
    type: "date",
  },
  {
    source: `${FIELD_DATA.resolved_date_filter}__end_range`,
    placeholder: `${FORM_DATA.dispute_resolved_date}(To)`,
    type: "date",
  },
];

export const tableChipsFormatter = () => (filter, value) => {
  switch (filter) {
    case `${FIELD_DATA.customer_name}__icontains`:
      return `${FORM_DATA.customer_name}: ${value}`;
    case `${FIELD_DATA.customer_email}__icontains`:
      return `${FORM_DATA.customer_email}: ${value}`;
    case `${FIELD_DATA.customer_phone_number}__icontains`:
      return `${FORM_DATA.customer_phone}: ${value}`;
    case `${FIELD_DATA.listing_title}__icontains`:
      return `${FORM_DATA.listing_title}: ${value}`;
    case FIELD_DATA.listing_type: {
      const listing = listingTypeOptions?.find((item) => item.id == value);
      return `${FORM_DATA.listing_type}: ${listing?.name}`;
    }
    case FIELD_DATA.status: {
      const status = DISPUTE_STATUS_FILTER_OPTIONS?.find(
        (option) => option.value == value
      );
      return `${FORM_DATA.dispute_status}: ${status?.label}`;
    }
    case FIELD_DATA.dispute_due_date: {
      const filterString = getDisputeDueDateSetFilterTag({ value });
      return `${FORM_DATA.dispute_due_date}: ${filterString}`;
    }
    case `${FIELD_DATA.dispute_due_date}__lte`: {
      const date = parse(value, DEFAULT_YEAR_MONTH_DATE_FORMAT, new Date());
      const today = new Date();
      if (isSameDay(date, addDays(today, DAY_OFFSETS.YESTERDAY))) {
        return `${FORM_DATA.dispute_due_date}: Expired`;
      } else {
        return null;
      }
    }
    case `${FIELD_DATA.dispute_due_date}__gte`: {
      return `${FORM_DATA.dispute_due_date}: Due within 7 days`;
    }
    case `${FIELD_DATA.raised_date_filter}__start_range`:
      return `${FORM_DATA.dispute_raised_date}(From): ${format(
        new Date(value),
        DATE_WITH_FULL_MONTH_FORMAT
      )}`;
    case `${FIELD_DATA.raised_date_filter}__end_range`:
      return `${FORM_DATA.dispute_raised_date}(To): ${format(
        new Date(value),
        DATE_WITH_FULL_MONTH_FORMAT
      )}`;
    case `${FIELD_DATA.resolved_date_filter}__start_range`:
      return `${FORM_DATA.dispute_resolved_date}(From): ${format(
        new Date(value),
        DATE_WITH_FULL_MONTH_FORMAT
      )}`;
    case `${FIELD_DATA.resolved_date_filter}__end_range`:
      return `${FORM_DATA.dispute_resolved_date}(To): ${format(
        new Date(value),
        DATE_WITH_FULL_MONTH_FORMAT
      )}`;
    default:
      return;
  }
};
